<template>
  <svg
    width="17"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6101 0.744857C16.7277 0.315857 16.6101 0 16.047 0H14.1876C13.7145 0 13.4963 0.272643 13.378 0.573571C13.378 0.573571 12.4324 3.08471 11.093 4.71586C10.6595 5.18886 10.4626 5.33893 10.226 5.33893C10.1077 5.33893 9.92992 5.18886 9.92992 4.75907V0.744857C9.92992 0.229428 9.79959 0 9.40576 0H6.48182C6.18645 0 6.00867 0.238857 6.00867 0.465929C6.00867 0.953857 6.67873 1.067 6.74744 2.44043V5.42457C6.74744 6.07907 6.63907 6.19771 6.40249 6.19771C5.77209 6.19771 4.23858 3.67479 3.32839 0.788071C3.15202 0.226286 2.97352 0 2.49824 0H0.637487C0.106248 0 0 0.272643 0 0.573571C0 1.10943 0.630403 3.77143 2.93598 7.29221C4.47303 9.6965 6.63694 11 8.60819 11C9.79038 11 9.93629 10.7109 9.93629 10.2119V8.39457C9.93629 7.8155 10.0482 7.7 10.4229 7.7C10.6992 7.7 11.1716 7.85086 12.2752 9.00978C13.536 10.384 13.7435 11 14.4532 11H16.3126C16.8438 11 17.1101 10.7109 16.9571 10.1389C16.7886 9.57 16.1865 8.74421 15.3882 7.76443C14.9547 7.20657 14.3045 6.6055 14.1069 6.30457C13.8313 5.91879 13.91 5.74671 14.1069 5.40336C14.1069 5.40336 16.3742 1.92579 16.6101 0.744857Z"
    />
  </svg>
</template>
